import { TRANSFER_ORDER_TYPE } from "constants/order";
import React from "react";
import ListTransportLocalities from "./ListTransportLocalities";

const ListTransportLocalitiesReceive = () => {
  return (
    <React.Fragment>
      <ListTransportLocalities orderType={TRANSFER_ORDER_TYPE.RECEIVE} />
    </React.Fragment>
  );
};

export default ListTransportLocalitiesReceive;
